import { zodResolver } from "@hookform/resolvers/zod";
import { Stack } from "@mui/material";
import { useRecordContext } from "react-admin";

import { AddressQuickActions } from "./AddressQuickActions";
import { fmtDateTimeDE } from "../components/raFormat";
import {
  AppEdit,
  AppFormContent,
  AppFormSection,
  AppSimpleForm,
  RecordMetaCard,
  SectionHeader,
  AppTextInput,
  AppFormToolbar,
} from "../../layout";
import {
  addressEditFormSchema,
} from "../schemas";
import { toUpdateAddressCommand } from "../mappers";

export function AddressMeta() {
  const r = useRecordContext<any>();
  if (!r) return null;

  const coords =
    r.lat != null && r.lon != null
      ? `${r.lat.toFixed(6)}, ${r.lon.toFixed(6)}`
      : "—";

  return (
    <RecordMetaCard
      title="Systemdaten"
      rows={[
        { label: "Koordinaten", value: coords },
        { label: "Erstellt", value: fmtDateTimeDE(r.createdAt) },
        { label: "Aktualisiert", value: fmtDateTimeDE(r.updatedAt) },
        { label: "Version", value: r.version ?? "—" },
      ]}
    />
  );
}

function AddressEditFields() {
  return (
    <>
      <AppTextInput source="label" label="Bezeichnung" fullWidth />

      <AppTextInput source="street" label="Straße" required fullWidth />

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <AppTextInput
          source="streetNumber"
          label="Nr."
          required
          sx={{ width: { xs: "100%", sm: 135 } }}
        />
      </Stack>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <AppTextInput
          source="zip"
          label="PLZ"
          required
          sx={{ width: { xs: "100%", sm: 180 } }}
        />
        <AppTextInput source="city" label="Ort" required fullWidth />
      </Stack>

      <AppTextInput
        source="country"
        label="Land"
        helperText="z. B. DE"
        sx={{ width: { xs: "100%", sm: 135 } }}
      />
    </>
  );
}

export const AddressEdit = () => (
  <AppEdit
    mutationMode="pessimistic"
    aside={<AddressMeta />}
    transform={toUpdateAddressCommand}
  >
    <AppSimpleForm
      resolver={zodResolver(addressEditFormSchema) as any}
      mode="onBlur"
      toolbar={<AppFormToolbar />}
    >
      <AppFormSection>
        <SectionHeader
          title="Schnellaktionen"
          subtitle="Hilfen rund um die Adresse."
        />

        <AppFormContent>
          <AddressQuickActions />
        </AppFormContent>
      </AppFormSection>

      <AppFormSection>
        <SectionHeader
          title="Adressdaten"
          subtitle="Bearbeitbare Angaben zur Adresse."
        />

        <AppFormContent>
          <AddressEditFields />
        </AppFormContent>
      </AppFormSection>
    </AppSimpleForm>
  </AppEdit>
);
